/**
 * Project Shell — wraps project pages with the project-aware Topbar.
 */
import { useState, useEffect } from "react";
import { useParams, Outlet } from "react-router-dom";
import { api } from "../lib/api.ts";
import { Topbar } from "../components/shared/Topbar.tsx";

export function ProjectShell() {
  const { id } = useParams<{ id: string }>();
  const [project, setProject] = useState<any>(null);
  const [alerts, setAlerts] = useState<any[]>([]);

  useEffect(() => {
    if (id) {
      api.getProject(id).then(setProject).catch(() => {});
      api.getProjectAlerts(id).then(setAlerts).catch(() => {});
    }
  }, [id]);

  function handleDismissAlert(alertId: string) {
    if (!id) return;
    api.dismissAlert(id, alertId).then(() => {
      setAlerts(prev => prev.filter(a => a.id !== alertId));
    }).catch(console.error);
  }

  function handleRenamed(newName: string) {
    setProject((prev: any) => prev ? { ...prev, name: newName } : prev);
  }

  return (
    <>
      <Topbar
        projectName={project?.name}
        projectId={id}
        countryCode={project?.country_code}
        alerts={alerts}
        onDismissAlert={handleDismissAlert}
        onProjectRenamed={handleRenamed}
      />
      <Outlet />
    </>
  );
}
